import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";
import { getConfig } from "@edx/frontend-platform";
import {
  injectIntl,
  intlShape,
  FormattedDate,
} from "@edx/frontend-platform/i18n";
import { Spinner } from "@openedx/paragon";

import LmsHtmlFragment from "../outline-tab/LmsHtmlFragment";
import messages from "./messages";

import "./UpdatesTab.scss";

const UpdatesTab = ({ intl }) => {
  const { courseId } = useParams();
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUpdates = async () => {
      try {
        setLoading(true);
        const url = `${
          getConfig().LMS_BASE_URL
        }/api/mobile/v0.5/course_info/${courseId}/updates`;
        const { data } = await getAuthenticatedHttpClient().get(url);
        setUpdates(data || []);
      } catch (err) {
        console.error("Error fetching updates:", err);
        setUpdates([]);
      } finally {
        setLoading(false);
      }
    };

    if (courseId) {
      fetchUpdates();
    }
  }, [courseId]);

  if (loading) {
    return (
      <div
        className="updates-tab-content d-flex justify-content-center align-items-center"
        style={{ minHeight: "400px" }}
      >
        <Spinner
          animation="border"
          className="mie-3"
          screenReaderText={intl.formatMessage(messages.loading)}
        />
      </div>
    );
  }

  // Filter visible updates
  const visibleUpdates = updates.filter(
    (update) => update.status === "visible"
  );

  return (
    <div className="updates-tab-content container-xl my-4">
      <h1 className="h2 mb-3">{intl.formatMessage(messages.title)}</h1>
      {visibleUpdates.length === 0 && (
        <p className="text-muted">{intl.formatMessage(messages.noUpdates)}</p>
      )}
      {visibleUpdates.map((update) => (
        <section key={update.id} className="mb-4">
          {update.date && (
            <p className="small text-muted mb-2">
              <FormattedDate
                value={update.date}
                day="numeric"
                month="short"
                year="numeric"
              />
            </p>
          )}
          <LmsHtmlFragment
            html={update.content}
            title="Update"
            className="inline-link"
          />
        </section>
      ))}
    </div>
  );
};

UpdatesTab.propTypes = {
  intl: intlShape.isRequired,
};

export default injectIntl(UpdatesTab);
